import { Layout } from "components";
import { styled } from "@mui/system";
import { Box, CircularProgress, Grid2 } from "@mui/material";
import { Checkbox, Typography } from "theme";
import { SubmitHandler, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { CheckInInfoFormScheme, checkInSchema } from "./validation.ts";
import { useCallback, useEffect } from "react";
import { InvertButton } from "../../theme/components/Button/Button.tsx";
import { useCheckIn } from "../../api/hooks/useCheckIn/useCheckIn.ts";
import { useUsers } from "../../api/hooks/useUsers/useUsers.ts";
import { useCheckInStatus } from "../../api/hooks/useCheckInStatus/useCheckInStatus.tsx";
import { format } from "date-fns";

const FormWrapper = styled(Box)(() => ({
  display: "flex",
  justifyContent: 'center',
  alignItems: 'center',
}));

const StyledForm = styled(Box)(() => ({
  maxWidth: '454px',
  width: '100%',
}));

const CheckIn = () => {
  const { data = [], isFetching } = useUsers();
  const { mutateAsync, isPending } = useCheckIn();
  const { data: statuses = [], isFetching: isStatusesFetching} = useCheckInStatus();
  const {
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm<CheckInInfoFormScheme>({
    reValidateMode: "onSubmit",
    resolver: zodResolver(checkInSchema),
    defaultValues: {
      ids: []
    },
  });

  useEffect(() => {
    if (statuses.length > 0){
      setValue('ids', statuses.map((el) => String(el.administratorId)));
    }
  },[statuses]);

  const onSubmit:SubmitHandler<CheckInInfoFormScheme> = useCallback(async (data) => {
    await mutateAsync(data.ids);
  }, [mutateAsync])

  if (isFetching || isStatusesFetching){
    return <Layout>
      <Grid2 container justifyContent="center">
        <CircularProgress color="secondary" />
      </Grid2>
    </Layout>
  }

  return (
    <Layout>
      <FormWrapper>
        <StyledForm>
          <Typography variant='h1' textTransform='uppercase' textAlign='center'>Відмітитись</Typography>
          <Typography mt={2} variant='body1' textTransform='uppercase' textAlign='left'>Дата: {format(new Date(), 'yyyy-MM-dd')}</Typography>
          <Box
            mt={3.5}
            component="form"
            id="sign-in-form"
            noValidate
            onSubmit={handleSubmit(onSubmit)}
          >
            <Box mt={2} display='flex' flexDirection='column' gap={1}>
              {
                data.map(el => <Box key={el.id} display='flex' alignItems='center'>
                  <label style={{
                    textAlign:'left',
                    flexGrow: 1
                  }} htmlFor={String(el.id)}> <Typography variant='body1' weight='semiBold' textTransform='uppercase'>{el.name}</Typography> </label>
                  <Checkbox id={String(el.id)} checked={watch('ids').includes(String(el.id))} onChange={(_, checked) => {
                    setValue('ids', checked ? [...watch('ids'), String(el.id)] : watch('ids').filter((i) => i !== String(el.id)));
                  }} />
                </Box>)
              }
            </Box>
            <Box mt={2}>
              {errors.ids?.message && <Typography color='error' variant='body2'>{errors.ids.message}</Typography>}
            </Box>
            <Box mt={4}>
              <InvertButton
                type="submit"
                form='sign-in-form'
                loading={isPending}
                size="large"
                fullWidth
              >
                Підтвердити
              </InvertButton>
            </Box>
          </Box>
        </StyledForm>
      </FormWrapper>
    </Layout>
  );
};

export default CheckIn;
